import { TableFieldsFragment } from 'api/graphql-types';
import { Typography } from 'components/typography';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';

import styles from './table-module.module.scss';

interface ITableModuleProps {
	module: TableFieldsFragment;
}

const TableModule = (props: ITableModuleProps): React.JSX.Element => {
	const backgroundColor = props.module?.defaultModuleOptions?.backgroundColor;
	const background = backgroundColor === 'white' ? styles.grey : backgroundColor === 'grey' && styles.white;

	return (
		<>
			{props.module?.tableTitle?.value && (
				<Typography tag={props.module.tableTitle?.type || 'h2'} className={styles.title} variant="h2">
					{sanitizeAndParseHtml(props.module.tableTitle.value)}
				</Typography>
			)}
			{props.module.table && (
				<div className={`${styles.schedulingTable} ${background}`}>{sanitizeAndParseHtml(props.module.table)}</div>
			)}
		</>
	);
};

export default TableModule;
